<template>
  <v-container fluid>
    <template>
      <v-card :loading="loading">
        <v-card-title>
          <h2>
            <v-btn
              depressed
              class="mx-2"
              fab
              small
              :to="{ name: 'ordem-medicao-list', path: 'lista' }"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <template>
              <span>OM {{ this.id_ordem }} - Equipamentos</span>
            </template>
          </h2>
        </v-card-title>

        <v-row justify="center">
          <v-dialog v-model="dialog" persistent max-width="850px" scrollable>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                v-if="
                  situacao == 'A' ||
                    perms.includes('ordemmedicao.analise_dir_operacional')
                "
                color="primary"
                dark
              >
                <v-icon class="mr-2">mdi-plus-box-multiple</v-icon>Item /
                Equipamento
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Adicionar</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-tabs v-model="tabs" grow>
                    <v-tab v-if="situacao == 'A' || situacao == 'B'">
                      <v-icon
                        left
                        color="error"
                        v-if="$v.$invalid"
                        class="mdi mdi-alert-circle"
                      ></v-icon>
                      <span>Item</span>
                    </v-tab>
                    <v-tab v-if="situacao == 'A' || situacao == 'B'">
                      <v-icon
                        left
                        color="error"
                        v-if="$v.$invalid"
                        class="mdi mdi-alert-circle"
                      ></v-icon>
                      <span>Equipamento</span>
                    </v-tab>

                    <v-tab v-if="situacao == 'A' || situacao == 'B'">
                      <v-icon
                        left
                        color="error"
                        v-if="$v.$invalid"
                        class="mdi mdi-alert-circle"
                      ></v-icon>
                      <span>Medição</span>
                    </v-tab>
                    <v-tab v-if="situacao == 'A' || situacao == 'B'">
                      <v-icon
                        left
                        color="error"
                        v-if="$v.$invalid"
                        class="mdi mdi-alert-circle"
                      ></v-icon>
                      <span>Cobrança</span>
                    </v-tab>
                    <v-tab>
                      <v-icon
                        left
                        color="error"
                        v-if="$v.$invalid"
                        class="mdi mdi-alert-circle"
                      ></v-icon>
                      <span>Despesas</span>
                    </v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tabs">
                    <v-tab-item v-if="situacao == 'A' || situacao == 'B'">
                      <v-card-text>
                        <v-autocomplete
                          v-model="item"
                          :error-messages="itemErrors"
                          :loading="loading"
                          :items="itens"
                          item-text="descricao"
                          item-value="id"
                          hide-no-data
                          hide-details
                          required
                          label="Item"
                        ></v-autocomplete>

                        <v-text-field
                          v-model="ordemServico"
                          :error-messages="ordemServicoErrors"
                          :counter="10"
                          label="Ordem Serviço"
                          @input="$v.ordemServico.$touch()"
                          @blur="$v.ordemServico.$touch()"
                        ></v-text-field>
                      </v-card-text>
                    </v-tab-item>
                    <v-tab-item v-if="situacao == 'A' || situacao == 'B'">
                      <v-card-text>
                        <v-autocomplete
                          v-model="equipamento"
                          :loading="loading"
                          :items="equipamentos"
                          item-text="descricao"
                          item-value="id"
                          hide-no-data
                          hide-details
                          label="Equipamento Utilizado"
                        ></v-autocomplete>

                        <autocomplete-taxonomia
                          v-model="equipamento_medicao"
                          label="Equipamento Medição"
                          dicionario="equipamentos_medicao"
                          hint="Trata-se da descrição que aparecerá para o cliente na medição a ser enviada"
                        />

                        <v-menu
                          ref="menu1"
                          v-model="menu1"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="dataMedicao"
                              :error-messages="dataMedicaoErrors"
                              label="Data OS / Serviço"
                              v-on="on"
                              required
                              @input="$v.dataMedicao.$touch()"
                              @blur="$v.dataMedicao.$touch()"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dateMedicao"
                            no-title
                            @input="menu1 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-card-text>
                    </v-tab-item>

                    <v-tab-item v-if="situacao == 'A' || situacao == 'B'">
                      <v-card-text>
                        <v-text-field
                          v-model="saidaGaragem"
                          v-mask="'decimal2'"
                          :error-messages="saidaGaragemErrors"
                          :counter="5"
                          label="Hora Início"
                          @input="$v.saidaGaragem.$touch()"
                          @blur="$v.saidaGaragem.$touch()"
                          class="valorDecimal"
                        ></v-text-field>
                        <v-text-field
                          v-model="chegadaGaragem"
                          v-mask="'decimal2'"
                          :error-messages="chegadaGaragemErrors"
                          :counter="5"
                          label="Hora Fim"
                          @input="$v.chegadaGaragem.$touch()"
                          @blur="$v.chegadaGaragem.$touch()"
                        ></v-text-field>
                        <h4>Total Medido: {{ calculoDiferenca }}</h4>
                        <v-text-field
                          v-model="totalCobrar"
                          :error-messages="totalCobrarErrors"
                          :counter="5"
                          v-mask="'decimal2'"
                          label="Total Cobrar"
                          @input="$v.totalCobrar.$touch()"
                          @blur="$v.totalCobrar.$touch()"
                        ></v-text-field>
                        <v-text-field
                          v-model="observacao"
                          :error-messages="observacaoErrors"
                          :counter="300"
                          label="Observação"
                          @input="$v.observacao.$touch()"
                          @blur="$v.observacao.$touch()"
                        ></v-text-field>
                      </v-card-text>
                    </v-tab-item>
                    <v-tab-item v-if="situacao == 'A' || situacao == 'B'">
                      <v-card-text>
                        <v-text-field
                          v-model="valorCobrar"
                          v-mask="'money'"
                          :error-messages="valorCobrarErrors"
                          maxlength="15"
                          label="Valor à Cobrar R$"
                          required
                          @input="$v.valorCobrar.$touch()"
                          @blur="$v.valorCobrar.$touch()"
                        ></v-text-field>

                        <v-autocomplete
                          v-model="unidadeMedidaValor"
                          :error-messages="unidadeMedidaValorErrors"
                          :loading="loading"
                          :items="unidadeMedidas"
                          item-text="descricao"
                          item-value="id"
                          hide-no-data
                          hide-details
                          required
                          label="Unidade Medida"
                        ></v-autocomplete>

                        <v-text-field
                          v-model="descontoItem"
                          v-mask="'money'"
                          maxlength="15"
                          label="Desconto na OS (R$)"
                        ></v-text-field>

                        <v-text-field
                          label="CUSTOS"
                          disabled="disabled"
                        ></v-text-field>

                        <v-switch
                          v-model="tem_bonificacao"
                          label="Bonificação"
                        ></v-switch>
                        <template v-if="tem_bonificacao">
                          <v-autocomplete
                            v-model="tipoBonificacao"
                            :loading="loading"
                            :items="tiposBonificacao"
                            item-text="descricao"
                            item-value="id"
                            hide-no-data
                            hide-details
                            label="Tipo Bonificação"
                          ></v-autocomplete>

                          <v-text-field
                            v-model="bonificacaoVenda"
                            v-mask="'decimal2'"
                            :error-messages="bonificacaoVendaErrors"
                            :maxlength="tipoBonificacao === 'P' ? 5 : 15"
                            label="BV Valor"
                            :suffix="tipoBonificacao === 'P' ? '%' : ''"
                            :prefix="tipoBonificacao === 'P' ? '' : 'R$'"
                            @input="$v.bonificacaoVenda.$touch()"
                            @blur="$v.bonificacaoVenda.$touch()"
                          ></v-text-field>

                          <v-autocomplete
                            v-model="unidadeMedidaBV"
                            :items="unidadeMedidas"
                            item-text="descricao"
                            item-value="id"
                            hide-no-data
                            hide-details
                            label="Unidade Medida"
                            disabled
                          ></v-autocomplete>

                          <v-text-field
                            v-model="descontoBV"
                            v-mask="'money'"
                            maxlength="15"
                            label="Desconto R$"
                          ></v-text-field>

                          <v-text-field
                            v-model="bvNome"
                            :error-messages="bvNomeErrors"
                            :counter="100"
                            label="BV Nome"
                            @input="$v.bvNome.$touch()"
                            @blur="$v.bvNome.$touch()"
                          ></v-text-field>
                        </template>

                        <v-switch
                          v-model="equipamento_terceiro"
                          label="Equipamento de Terceiro"
                        ></v-switch>
                        <template v-if="equipamento_terceiro">
                          <v-text-field
                            v-model="descricaoTerceiro"
                            :error-messages="descricaoTerceiroErrors"
                            :counter="200"
                            label="Terceiro"
                            @input="$v.descricaoTerceiro.$touch()"
                            @blur="$v.descricaoTerceiro.$touch()"
                          ></v-text-field>

                          <v-text-field
                            v-model="valorPagarTerceiro"
                            v-mask="'money'"
                            :error-messages="valorPagarTerceiroErrors"
                            maxlength="15"
                            label="Valor à Pagar R$"
                            @input="$v.valorPagarTerceiro.$touch()"
                            @blur="$v.valorPagarTerceiro.$touch()"
                          ></v-text-field>

                          <v-autocomplete
                            v-model="unidadeMedidaTerceiro"
                            :items="unidadeMedidas"
                            item-text="descricao"
                            item-value="id"
                            hide-no-data
                            hide-details
                            disabled
                            label="Unidade Medida"
                          ></v-autocomplete>

                          <v-text-field
                            v-model="descontoTerceiro"
                            v-mask="'money'"
                            maxlength="15"
                            label="Desconto R$"
                          ></v-text-field>
                        </template>
                      </v-card-text>
                    </v-tab-item>

                    <v-tab-item>
                      <v-card-text>
                        <v-text-field
                          v-model="custoProducao"
                          v-mask="'money'"
                          :error-messages="custoProducaoErrors"
                          maxlength="15"
                          label="Plano de rigging R$"
                          :disabled="habilitaCustos"
                          @input="$v.custoProducao.$touch()"
                          @blur="$v.custoProducao.$touch()"
                        ></v-text-field>

                        <v-text-field
                          v-model="custoArt"
                          v-mask="'money'"
                          :error-messages="custoArtErrors"
                          :counter="15"
                          label="Custo ART R$"
                          :disabled="habilitaCustos"
                          @input="$v.custoArt.$touch()"
                          @blur="$v.custoArt.$touch()"
                        ></v-text-field>

                        <v-text-field
                          v-model="custoCet"
                          v-mask="'money'"
                          :counter="15"
                          :disabled="habilitaCustos"
                          label="Custo Interdição/CET R$"
                        ></v-text-field>

                        <v-text-field
                          v-model="custoOutros"
                          v-mask="'money'"
                          :counter="15"
                          :disabled="habilitaCustos"
                          label="Outros Custo R$"
                        ></v-text-field>
                      </v-card-text>
                    </v-tab-item>
                  </v-tabs-items>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="fecharDialog()"
                  >Fechar</v-btn
                >
                <v-btn color="blue darken-1" text @click="salvar()"
                  >Salvar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

        <v-data-table :headers="headers" class="elevation-1" :items="users">
          <template v-slot:item.data_medicao="{ item }">
            <span>{{ DataBR(item.data_medicao.substr(0, 10)) }}</span>
          </template>

          <template v-slot:item.id_equipamento_usado="{ item }">
            <span class="caption">{{ strEquipamentoUsado(item) }}</span>
            <br />
            {{ strEquipamentoMedicao(item) }}
          </template>

          <template v-slot:item.hora_inicio="{ item }">
            <span>{{ maskDecimal2(item.hora_inicio) }}</span>
          </template>
          <template v-slot:item.hora_fim="{ item }">
            <span>{{ maskDecimal2(item.hora_fim) }}</span>
          </template>
          <template v-slot:item.horas_cobrar="{ item }">
            <span>{{ maskDecimal2(item.horas_cobrar) }}</span>
          </template>
          <template v-slot:item.valor_cobrar="{ item }">
            <span>{{ maskMoney(item.valor_cobrar) }}</span>
          </template>
          <template v-slot:item.total_medido="{ item }">
            <span>{{ maskDecimal2(item.hora_fim - item.hora_inicio) }}</span>
          </template>
          <template v-slot:item.valor_total="{ item }">
            <span>
              {{
                item.horas_cobrar === null
                  ? maskMoney(item.valor_cobrar)
                  : maskMoney(item.horas_cobrar * item.valor_cobrar)
              }}
            </span>
          </template>

          <template v-slot:item.sequencia="{ item }">

            <v-btn
             v-if="
                item.sequencia  > '1' 
              "
              icon
              small
              text
              @click="upItem(item.id_ordem,item.id,item.sequencia)"
            >
              <v-icon title="Subir Item" class="mdi mdi-arrow-up" small />
            </v-btn>

            <v-btn
              v-if="
                item.sequencia  < usersQtd
              "
              icon
              small
              text
              @click="downItem(item.id_ordem,item.id,item.sequencia)"
            >
              <v-icon title="Descer Item" class="mdi mdi-arrow-down" small />
            </v-btn>


          </template>
          <template v-slot:item.actions="{ item }">
            

            <v-btn
              v-if="
                situacao == 'A' ||
                  perms.includes('ordemmedicao.analise_dir_operacional')
              "
              icon
              small
              text
              @click="abrirItemMedicao(item.id, 2)"
            >
              <v-icon title="Editar Equipamento" class="mdi mdi-pencil" small />
            </v-btn>
            <v-btn
              v-if="
                situacao == 'A' ||
                  perms.includes('ordemmedicao.analise_dir_operacional')
              "
              icon
              small
              text
              @click="abrirItemMedicao(item.id, 1)"
            >
              <v-icon
                title="Copiar Medição"
                class="mdi mdi-file-plus-outline"
                small
              />
            </v-btn>
            <dialog-confirm
              titulo="Deletar Equipamento"
              texto="Confirma a exclusão?"
              @confirmar="deletar(item.id)"
              v-if="
                situacao == 'A' ||
                  perms.includes('ordemmedicao.analise_dir_operacional')
              "
            >
              <v-btn icon small text>
                <v-icon class="mdi mdi-delete" small />
              </v-btn>
            </dialog-confirm>

            <v-btn
              v-if="
                situacao != 'A' &&
                  situacao != 'B' &&
                  situacao != 'J' &&
                  perms.includes('ordemmedicao.campos_custos')
              "
              icon
              small
              text
              @click="abrirItemMedicao(item.id, 2)"
            >
              <v-icon title="Editar Despesas" class="mdi mdi-pencil" small />
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, maxLength, numeric } from "vuelidate/lib/validators";
import DialogConfirm from "../components/DialogConfirm";
import AutocompleteTaxonomia from "../components/taxonomia/AutocompleteTaxonomia";
import moment from "moment";
import number_format_lib from "../lib/number_format";
import { build, unmaskDecimal } from "../lib/masks";

export default {
  mixins: [validationMixin],

  validations: {
    item: { required },
    dataMedicao: { required },
    saidaGaragem: { maxLength: maxLength(5) },
    chegadaGaragem: { maxLength: maxLength(5) },
    totalCobrar: { maxLength: maxLength(5) },
    observacao: { maxLength: maxLength(300) },
    ordemServico: { numeric, maxLength: maxLength(10) },

    valorCobrar: { required, maxLength: maxLength(15) },
    custoArt: { maxLength: maxLength(15) },
    custoProducao: { maxLength: maxLength(15) },
    unidadeMedidaValor: { required, maxLength: maxLength(50) },
    bonificacaoVenda: { maxLength: maxLength(15) },
    bvNome: { maxLength: maxLength(100) },
    valorPagarTerceiro: { maxLength: maxLength(15) },
    descricaoTerceiro: { maxLength: maxLength(200) },
  },

  components: { DialogConfirm, AutocompleteTaxonomia },

  data() {
    return {
      id: "",
      id_ordem: "",
      id_ordem_item: "",
      item: "",
      ordemServico: "",
      equipamento: null,
      equipamento_medicao: null,
      saidaGaragem: "",
      chegadaGaragem: "",
      diferencaGaragem: 0,
      totalCobrar: "",
      observacao: "",
      valorCobrar: "",
      custoProducao: "",
      custoArt: "",
      custoCet: "",
      custoOutros: "",
      unidadeMedidaValor: "",
      bonificacaoVenda: "",
      descricaoTerceiro: "",
      valorPagarTerceiro: "",
      bvNome: "",
      dialog: false,
      equipamentos: [],
      loading: false,
      tabs: null,
      equipamento_terceiro: false,
      tem_bonificacao: false,
      itens: [],
      unidadeMedidas: [],
      edicao: "",
      tipoBonificacao: "",
      tiposBonificacao: [
        { descricao: "Percentual", id: "P" },
        { descricao: "Valor", id: "V" },
      ],
      situacao: "A",
      habilitaCustos: true,
      unidadeMedidaBV: null,
      unidadeMedidaTerceiro: null,
      descontoBV: "",
      descontoTerceiro: "",
      descontoItem: "",
      

      headers: [
        { text: "Data", value: "data_medicao" },
        { text: "Item", value: "item.descricao" },
        { text: "Equipamento", value: "id_equipamento_usado" },
        { text: "OS", value: "numero_os" },
        { text: "Hora Início", value: "hora_inicio" },
        { text: "Hora Fim", value: "hora_fim" },
        { text: "Un. Medida", value: "unidade_cobranca.codigo" },
        { text: "Total Medido", value: "total_medido" },
        { text: "Total Cobrar", value: "horas_cobrar" },
        { text: "Valor Cobrar Un. (R$)", value: "valor_cobrar" },
        { text: "Valor Cobrar Total (R$)", value: "valor_total" },
        { text: "", value: "despesa", sortable: false, align: "center" },
        { text: "", value: "sequencia", sortable: false, align: "center" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],

      dateMedicao: "",
      dataMedicao: "",
      menu1: false,
    };
  },
  computed: {
    ...mapState({
      perms: (state) => state.usuarios.usuarioAtivo.permissoes,
    }),
    calculoDiferenca() {
      return build.decimal2(
        unmaskDecimal(this.chegadaGaragem) - unmaskDecimal(this.saidaGaragem) <
          10
          ? 10
          : unmaskDecimal(this.chegadaGaragem) -
              unmaskDecimal(this.saidaGaragem)
      );
    },
    users() {
      return this.$store.state.ordemMedicao.OrdemMedicaoItens;
    },
    usersQtd() {
      return this.$store.state.ordemMedicao.OrdemMedicaoItens.length;
    },
    itemErrors() {
      const errors = [];
      if (!this.$v.item.$dirty) return errors;
      !this.$v.item.required && errors.push("Campo é Obrigatório.");
      return errors;
    },
    dataMedicaoErrors() {
      const errors = [];
      if (!this.$v.dataMedicao.$dirty) return errors;
      !this.$v.dataMedicao.required && errors.push("Campo é Obrigatório.");
      return errors;
    },
    saidaGaragemErrors() {
      const errors = [];
      if (!this.$v.saidaGaragem.$dirty) return errors;
      !this.$v.saidaGaragem.maxLength && errors.push("Somente 5 caracteres.");

      return errors;
    },
    chegadaGaragemErrors() {
      const errors = [];
      if (!this.$v.chegadaGaragem.$dirty) return errors;
      !this.$v.chegadaGaragem.maxLength && errors.push("Somente 5 caracteres.");

      return errors;
    },
    totalCobrarErrors() {
      const errors = [];
      if (!this.$v.totalCobrar.$dirty) return errors;
      !this.$v.totalCobrar.maxLength && errors.push("Somente 5 caracteres.");

      return errors;
    },
    custoProducaoErrors() {
      const errors = [];
      if (!this.$v.custoProducao.$dirty) return errors;
      !this.$v.custoProducao.maxLength && errors.push("Somente 15 caracteres.");

      return errors;
    },
    custoArtErrors() {
      const errors = [];
      if (!this.$v.custoArt.$dirty) return errors;
      !this.$v.custoArt.maxLength && errors.push("Somente 15 caracteres.");

      return errors;
    },
    observacaoErrors() {
      const errors = [];
      if (!this.$v.observacao.$dirty) return errors;
      !this.$v.observacao.maxLength && errors.push("Somente 300 caracteres.");

      return errors;
    },
    bvNomeErrors() {
      const errors = [];
      if (!this.$v.bvNome.$dirty) return errors;
      !this.$v.bvNome.maxLength && errors.push("Somente 100 caracteres.");

      return errors;
    },
    unidadeMedidaValorErrors() {
      const errors = [];
      if (!this.$v.unidadeMedidaValor.$dirty) return errors;
      !this.$v.unidadeMedidaValor.required &&
        errors.push("Unidade de Medida é Obrigatório.");
      !this.$v.unidadeMedidaValor.maxLength &&
        errors.push("Somente 50 caracteres.");

      return errors;
    },
    descricaoTerceiroErrors() {
      const errors = [];
      if (!this.$v.descricaoTerceiro.$dirty) return errors;
      !this.$v.descricaoTerceiro.maxLength &&
        errors.push("Somente 200 caracteres.");

      return errors;
    },
    valorCobrarErrors() {
      const errors = [];
      if (!this.$v.valorCobrar.$dirty) return errors;
      !this.$v.valorCobrar.required &&
        errors.push("Valor à Cobrar é Obrigatório.");
      !this.$v.valorCobrar.maxLength && errors.push("Somente 15 caracteres.");

      return errors;
    },
    ordemServicoErrors() {
      const errors = [];
      if (!this.$v.ordemServico.$dirty) return errors;
      !this.$v.ordemServico.maxLength && errors.push("Somente 10 caracteres.");
      !this.$v.ordemServico.numeric && errors.push("Somente número.");

      return errors;
    },
    bonificacaoVendaErrors() {
      const errors = [];
      if (!this.$v.bonificacaoVenda.$dirty) return errors;
      !this.$v.bonificacaoVenda.maxLength &&
        errors.push("Somente 15 caracteres.");

      return errors;
    },
    valorPagarTerceiroErrors() {
      const errors = [];
      if (!this.$v.valorPagarTerceiro.$dirty) return errors;
      !this.$v.valorPagarTerceiro.maxLength &&
        errors.push("Somente 15 caracteres.");

      return errors;
    },
    computeddataMedicao() {
      return this.formatDate(this.dateMedicao);
    },
  },
  watch: {
    dateMedicao() {
      this.dataMedicao = this.formatDate(this.dateMedicao);
    },
    calculoDiferenca() {
      if (this.edicao == "") {
        this.totalCobrar =
          this.chegadaGaragem - this.saidaGaragem < 10
            ? 10
            : this.chegadaGaragem - this.saidaGaragem;
      }
    },
    unidadeMedidaValor() {
      this.unidadeMedidaBV = this.unidadeMedidaValor;
      this.unidadeMedidaTerceiro = this.unidadeMedidaValor;
    },
  },
  methods: {
    limparCampos() {
      this.id_ordem_item = "";
      this.item = "";
      this.ordemServico = "";
      this.equipamento = "";
      this.equipamento_medicao = null;
      this.dataMedicao = "";
      this.dateMedicao = "";
      this.saidaGaragem = "";
      this.chegadaGaragem = "";
      this.totalCobrar = "";
      this.observacao = "";
      this.valorCobrar = "";
      this.custoProducao = "";
      this.custoArt = "";
      this.custoCet = "";
      this.custoOutros = "";
      this.unidadeMedidaValor = "";
      this.tem_bonificacao = false;
      this.tipoBonificacao = "";
      this.bvNome = "";
      this.bonificacaoVenda = "";
      this.equipamento_terceiro = false;
      this.descricaoTerceiro = "";
      this.valorPagarTerceiro = "";
      this.edicao = "";
      this.unidadeMedidaBV = null;
      this.unidadeMedidaTerceiro = null;
      this.descontoBV = "";
      this.descontoTerceiro = "";
      this.descontoItem = "";
    },
    fecharDialog() {
      this.limparCampos();
      this.dialog = false;
    },
    async abrirItemMedicao(id_ordem_item, acao) {
      // acao: 1 = copiar, 2 = editar
      try {
        var response = await this.$store.dispatch("ordemMedicao/carregarItem", {
          id_ordem: this.id_ordem,
          id_item: id_ordem_item,
        });

        if (acao == 2) this.id_ordem_item = id_ordem_item;

        //console.log(response);
        this.item = response.id_item;
        if (acao == 2) this.ordemServico = response.numero_os;
        this.equipamento = response.id_equipamento_usado;
        this.equipamento_medicao = response.id_equipamento_medicao;
        this.dataMedicao = this.DataBR(response.data_medicao.substr(0, 10));
        this.dateMedicao = response.data_medicao.substr(0, 10);
        if (acao == 1) {
          this.dataMedicao = "";
          this.dateMedicao = "";
        }
        this.saidaGaragem = build.decimal2(response.hora_inicio);
        this.chegadaGaragem = build.decimal2(response.hora_fim);

        this.observacao = response.observacao;
        this.valorCobrar = build.money(response.valor_cobrar);
        this.custoProducao = build.money(response.custo_producao);
        this.custoArt = build.money(response.custo_art);
        this.custoCet = build.money(response.custo_cet);
        this.custoOutros = build.money(response.custo_outros);
        this.unidadeMedidaValor = response.id_unidade_cobranca;
        this.tem_bonificacao = response.tem_bonificacao;
        this.tipoBonificacao = response.tipo_bonificacao;
        this.bvNome = response.nome_vendedor;
        this.bonificacaoVenda = build.decimal2(response.valor_bonificacao);
        this.equipamento_terceiro = response.usado_terceiro;
        this.descricaoTerceiro = response.nome_terceiro;
        this.valorPagarTerceiro = build.money(response.valor_pagar);
        this.totalCobrar = build.decimal2(response.horas_cobrar);
        this.edicao = "S";

        this.unidadeMedidaBV = response.id_unidade_bv;
        this.unidadeMedidaTerceiro = response.id_unidade_terceiro;
        this.descontoBV = build.money(response.desconto_bv);
        this.descontoTerceiro = build.money(response.desconto_terceiro);
        this.descontoItem = build.money(response.desconto_item);

        this.dialog = true;
      } catch (err) {
        //deu pau
      }
    },
    number_format(numero) {
      return number_format_lib(numero);
    },
    strEquipamentoUsado(equipamento) {
      if (equipamento.id_equipamento_usado == null) return "";

      return `${equipamento.equipamento_usado.descricao}`;
    },
    strEquipamentoMedicao(equipamento) {
      if (equipamento.id_equipamento_medicao == null) return "";
      return `${equipamento.equipamento_medicao.descricao}`;
    },
    async deletar(id_item) {
      await this.$store.dispatch("ordemMedicao/deletarItem", {
        id_ordem: this.id_ordem,
        id_item: id_item,
      });

      this.carregarItens();
    },
    async upItem(id_ordem,id_item) {
      try {
          await this.$store.dispatch("ordemMedicao/sobeItem", {
            id_ordem: id_ordem,
            id_ordem_item: id_item,
            });

      } catch (err) {
          console.log(err);
          this.loading = false;
          this.$store.commit("ui/setSnackbar", {
            text: "Não foi possível salvar",
          });
        }

      this.carregarItens();
    },
    async downItem(id_ordem,id_item) {
     try {
          await this.$store.dispatch("ordemMedicao/desceItem", {
            id_ordem: id_ordem,
            id_ordem_item: id_item,
            });

      } catch (err) {
          console.log(err);
          this.loading = false;
          this.$store.commit("ui/setSnackbar", {
            text: "Não foi possível salvar",
          });
        }

      this.carregarItens();
    },
    async salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          await this.$store.dispatch("ordemMedicao/gravarItem", {
            id_ordem_item: this.id_ordem_item,
            id_ordem: parseInt(this.id_ordem),
            data_medicao: this.DataSql(this.dataMedicao),
            id_item: this.item,
            numero_os: parseInt(this.ordemServico),
            id_equipamento_usado: parseInt(this.equipamento),
            id_equipamento_medicao: this.equipamento_medicao,
            hora_inicio: parseFloat(unmaskDecimal(this.saidaGaragem)),
            hora_fim: parseFloat(unmaskDecimal(this.chegadaGaragem)),
            horas_cobrar: parseFloat(unmaskDecimal(this.totalCobrar)),
            valor_cobrar: parseFloat(unmaskDecimal(this.valorCobrar)),
            custo_producao: parseFloat(unmaskDecimal(this.custoProducao)),
            custo_art: parseFloat(unmaskDecimal(this.custoArt)),
            custo_cet: parseFloat(unmaskDecimal(this.custoCet)),
            custo_outros: parseFloat(unmaskDecimal(this.custoOutros)),
            id_unidade_cobranca: this.unidadeMedidaValor,
            usado_terceiro: this.equipamento_terceiro,
            nome_terceiro: this.descricaoTerceiro,
            valor_pagar: parseFloat(unmaskDecimal(this.valorPagarTerceiro)),
            tem_bonificacao: this.tem_bonificacao,
            nome_vendedor: this.bvNome,
            tipo_bonificacao: this.tipoBonificacao,
            valor_bonificacao: parseFloat(unmaskDecimal(this.bonificacaoVenda)),
            observacao: this.observacao,
            sequencia: this.usersQtd+1,

            id_unidade_bv: this.unidadeMedidaBV,
            id_unidade_terceiro: this.unidadeMedidaTerceiro,
            desconto_bv: parseFloat(unmaskDecimal(this.descontoBV)),
            desconto_terceiro: parseFloat(unmaskDecimal(this.descontoTerceiro)),
            desconto_item: parseFloat(unmaskDecimal(this.descontoItem)),
          });

          this.carregarItens();

          this.limparCampos();

          this.dialog = false;
        } catch (err) {
          console.log(err);
          this.loading = false;
          this.$store.commit("ui/setSnackbar", {
            text: "Não foi possível salvar",
          });
        }
      }
    },
    async carregarItens() {
      try {
        await this.$store.dispatch("ordemMedicao/carregarItens", this.id_ordem);

        //this.preloader = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a listagem de dados",
        });
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    DataSql(dataBR) {
      if (!dataBR) return null;

      const [day, month, year] = dataBR.split("/");
      return `${year}-${month}-${day}T00:00:00Z`;
    },
    DataBR(dataSql) {
      if (!dataSql) return null;

      const [year, month, day] = dataSql.split("-");
      return `${day}/${month}/${year}`;
    },
    validaData(data) {
      if (data === "") return "-";
      return moment(data).format("DD/MM/YYYY");
    },
    maskDecimal2(val) {
      return build.decimal2(val);
    },
    maskMoney(val) {
      return build.money(val);
    },
  },
  async mounted() {
    //this.preloader = true;

    if (this.$route.params.id) {
      var id_ordem = this.$route.params.id;
      this.id_ordem = id_ordem;
      this.tituloNovo = false;

      this.carregarItens();

      try {
        const responseEquipamentos = await this.$store.dispatch(
          "ordemMedicao/carregarEquipamentos"
        );
        this.equipamentos = responseEquipamentos.data;
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar os equipamentos",
        });
      }

      try {
        const responseItem = await this.$store.dispatch("item/carregarItens");
        this.itens = responseItem.data;
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar os itens",
        });
      }

      try {
        const responseUnidadeMedida = await this.$store.dispatch(
          "unidadeMedida/carregarUnidadesMedidas"
        );
        this.unidadeMedidas = responseUnidadeMedida.data;
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar as unidades de medidas",
        });
      }

      try {
        var response = await this.$store.dispatch(
          "ordemMedicao/carregarOrdemMedicao",
          id_ordem
        );

        this.situacao = response.data.situacao;
      } catch (err) {
        //deu pau
      }
    }

    if (this.perms.includes("ordemmedicao.campos_custos")) {
      this.habilitaCustos = false;
    }
  },
};
</script>
